import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { Car, X } from "lucide-react";

const SOCKET_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:4000/api"
).replace(/\/api\/?$/, "");

function playDoorbell() {
  navigator.vibrate?.([200, 100, 200]);
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const playTone = (freq, start, dur) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(freq, start);
      osc.start(start);
      osc.stop(start + dur);
    };
    ctx.resume().then(() => {
      playTone(659, ctx.currentTime, 0.6);
      playTone(494, ctx.currentTime + 0.65, 0.8);
    });
  } catch {}
}

export default function TransportNotifier() {
  const user  = JSON.parse(localStorage.getItem("user") || "null");
  const token = localStorage.getItem("accessToken") || localStorage.getItem("token");
  const navigate = useNavigate();

  const [count, setCount]   = useState(0);
  const [show, setShow]     = useState(false);
  const socketRef = useRef(null);

  const isRyder = user?.role === "ryder";

  useEffect(() => {
    if (!isRyder || !token) return;

    const socket = io(SOCKET_URL, {
      transports: ["websocket", "polling"],
      auth: { token },
    });
    socketRef.current = socket;

    socket.on("transport:request_new", () => {
      playDoorbell();
      setCount((n) => n + 1);
      setShow(true);
    });

    return () => socket.disconnect();
  }, [isRyder, token]);

  if (!isRyder || !show) return null;

  return (
    <div
      className="fixed bottom-24 right-4 z-50 cursor-pointer"
      onClick={() => {
        setShow(false);
        setCount(0);
        navigate("/transport/conductor");
      }}
    >
      <div className="relative bg-supernova-500 text-white rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 min-w-[200px] animate-bounce">
        <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
          <Car size={20} />
        </div>
        <div className="flex-1">
          <p className="font-bold text-sm leading-tight">Nueva solicitud</p>
          <p className="text-xs text-white/80">de viaje disponible</p>
        </div>
        {count > 1 && (
          <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full text-xs flex items-center justify-center font-bold">
            {count}
          </span>
        )}
        <button
          onClick={(e) => { e.stopPropagation(); setShow(false); setCount(0); }}
          className="text-white/70 hover:text-white"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
